<template>
  <div class="rtl">
    <m-form
        :title="title"
        :items="items"
        :cols="cols"
        :canSubmit="canSubmit"
        :canDelete="canDelete"
        :is-editing.sync="isEditing"
        :showListBtn="false"
        :show-clear-btn="false"
        :show-navigation-btns="false"
        list-export-base-url="reports/lists/floatAccountGroups"
        :list_filters="{}"
        :exportParams="{id: item.id}"
        @click:row="setItem"
        @clearForm="clearForm"
        @submit="submit"
        @delete="deleteItem"
    >
      <template #header-btns>
        <v-btn  depressed class="primary rounded-lg white--text mr-1 mt-1 mt-md-0"  @click="clearForm"
        >  گروه حساب شناور</v-btn>
        <v-btn depressed class="secondary rounded-lg white--text mr-1 mt-1 mt-md-0" :to="`/panel/floatAccounts`"
        >  حساب شناور</v-btn>
      </template>

      <v-row>
        <v-col cols="12">
          <v-text-field class="rounded-lg" label=" * نام" v-model="item.name" :disabled="!isEditing"/>
        </v-col>
        <v-col cols="12">
          <v-textarea class="rounded-lg" label="توضیحات" v-model="item.explanation" :disabled="!isEditing"/>
        </v-col>
      </v-row>
    </m-form>
  </div>
</template>
<script>
import AccountApiMixin from "@/mixin/accountMixin";
import {MFormMixin} from "@/components/m-form";

export default {
  mixins: [MFormMixin, AccountApiMixin],
  props: {
    is_cost_center: {
      default: false,
    },
  },
  data() {
    return {
      baseUrl: "accounts/floatAccountGroups",
      permissionBasename: "floatAccountGroup",
      cols: [
        {
          text: "نام گروه حساب شناور",
          value: "name",
          type: "text",
          filters: ["name"],
        },
        {
          text: "توضیحات",
          value: "explanation",
          type: "text",
          filters: ["expalantion"],
        },
      ],
    };
  },
  computed: {
    title() {
      return "تعریف حساب های شناور > گروه حساب شناور";
    },
    items() {
      return this.floatAccountGroups;
    },
  },
  methods: {
    getItemTemplate() {
      return {
        is_cost_center: this.is_cost_center,
      };
    },
    getData() {
      this.getFloatAccountGroups(true);
    },
  },
};
</script>
